import { aiModelsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const AI_MODELS_ACTION_TYPE = createNamedActions('aiModels', {
  GET_AI_MODELS: 'GET_AI_MODELS',
});

export const getAiModelsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiModelsApi.getAiModels(params);

  return dispatch({
    type: AI_MODELS_ACTION_TYPE.GET_AI_MODELS,
    payload: data,
  });
});

export const syncAiModelsAction = catchAsyncActionError(() => async () => {
  await aiModelsApi.syncAiModels();
});
